import type { Arc } from '../plan/arc';
import { openInside } from '../plan/arc';
import { listOf } from '../entity/entity';
import type { CatalogMap } from '../entity/catalogStore';
import { arcHref } from '../routes/ArcRoute';
import { hrefFor } from '../routes/EntityPage';
import { nameOf } from '../workspaces/workspace';
import type { Workspace } from '../workspaces/workspace';
import { arcsCiting } from '../nook/nook';
import type { MarginRow } from './DocPage';

/** The live nooks that hold [path] among their members. */
export function nooksHolding(path: string, nooks: readonly Workspace[], catalog: CatalogMap): MarginRow[] {
  return nooks
    .filter((w) => !w.archived && w.sources.some((s) => s.path === path))
    .map((w) => {
      const { name, named } = nameOf(w, catalog);
      return {
        key: w.path,
        label: name,
        unnamedNook: named ? undefined : w,
        glyph: { kind: 'nook' as const, tags: w.tags },
        to: hrefFor(w.path),
        tags: w.tags,
      };
    });
}

/** The arcs whose `sources:` name [path], each as its state and name. */
export function arcsHolding(path: string, arcs: readonly Arc[] | null): MarginRow[] {
  return arcsCiting(path, arcs).map((arc) => ({
    key: arc.path,
    label: arc.title,
    meta: arcs && openInside(arc, arcs) > 0 ? `${openInside(arc, arcs)} inside` : undefined,
    glyph: { kind: 'status', status: arc.status },
    to: arcHref(arc.name),
    tags: listOf(arc.frontMatter['tags']),
  }));
}
